import { enrichTransactionRows } from './enrichTransactions';
import { buildEnterpriseCsvFilename } from './csvExport.shared';
import { escapeCsvCell, forceCsvText } from '../csvExport';
import { downloadBytes, encodeUtf8Csv } from './downloadFile';

export { buildEnterpriseCsvFilename } from './csvExport.shared';

const ENTERPRISE_HEADERS = [
  'Category',
  'Transaction Date',
  'Date & Time',
  'Receipt / Reference',
  'Client Name',
  'Company',
  'Machine Code',
  'Transaction Type',
  'Channel',
  'Status',
  'Credit (INR)',
  'Debit (INR)',
  'Base Amount (INR)',
  'GST 18% (INR)',
  'Total incl. GST (INR)',
  'Description',
];

function rowToCsvCells(row) {
  return [
    row.categoryLabel || 'Internal',
    row.displayDate,
    row.displayDateTime,
    forceCsvText(row.receiptRef),
    row.clientName,
    row.clientCompany,
    forceCsvText(row.machineCode),
    row.typeLabel,
    row.channelLabel,
    row.statusLabel,
    row.credit ? row.credit : '',
    row.debit ? row.debit : '',
    row.amount,
    row.gst,
    row.totalInclGst,
    row.descriptionClean,
  ];
}

export function buildEnterpriseCsv(transactions = [], ctx = {}, { preEnriched = false } = {}) {
  const rows = preEnriched ? transactions : enrichTransactionRows(transactions, ctx);
  const lines = [
    ENTERPRISE_HEADERS.map(escapeCsvCell).join(','),
    ...rows.map((r) => rowToCsvCells(r).map(escapeCsvCell).join(',')),
  ];
  return lines.join('\r\n');
}

export async function downloadCsvContent(content, filename) {
  const bytes = encodeUtf8Csv(content);
  await downloadBytes(bytes, filename, 'text/csv;charset=utf-8');
}

export async function exportFilteredReconciliationCsv(transactions, ctx, meta = {}, options = {}) {
  const csv = buildEnterpriseCsv(transactions, ctx, options);
  const filename = buildEnterpriseCsvFilename({
    from: meta.from,
    to: meta.to,
  });
  await downloadCsvContent(csv, filename);
  const rowCount = options.preEnriched
    ? transactions.length
    : enrichTransactionRows(transactions, ctx).length;
  return { filename, rowCount };
}
